export enum PageRoutes {
  Home = "/",
  Leaderboard = "/leaderboard",
  Settings = "/settings",
  Language = "/language",
  Faq = "/faq",
  PrivacyPolicy = "/privacy-policy",
  TermAndCondition = "/term-condition",
  Shop = "/shop",
  Me = "/me",
  EditProfile = "/edit-profile",
  Play = "/play",
  LeaderboardActivity = "/lb-activity",
  Onboarding = "/onboarding",
  Guest = "/guest",
}
